export const meta: BlockMeta = {
  title: "Button",
  tags: ["richtext"],
}

import { Button } from "@components/ui/Button"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/button", (props) => {
  return (
    <Button
      href={props.link?.url}
      target={props.link?.target || undefined}
      variant={props.variant || ("default" as any)}
      size={props.size || ("default" as any)}
      className="mt-2 mb-5"
    >
      <EditableText
        as="span"
        store="text"
        defaultValue="Example button text"
        placeholder="Example button text"
        plainText
      />
    </Button>
  )
})
